import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useThemeImages } from '@/hooks/useThemeImages';

export default function Footer() {
  const { t } = useTranslation();
  const themeImages = useThemeImages();

  const quickLinks = [
    { to: '/announcements', label: t('nav.announcements') },
    { to: '/competitions', label: t('nav.competitions') },
    { to: '/scores', label: t('nav.liveScores') },
    { to: '/schedule', label: t('nav.schedule') },
    { to: '/venues', label: t('nav.venues') },
    { to: '/transportation', label: t('nav.transportation') },
    { to: '/accommodation', label: t('nav.accommodation') },
    { to: '/contacts', label: t('nav.contacts') },
  ];

  return (
    <footer className="bg-header-bg text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Event Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={themeImages.logo} alt="" className="w-12 h-12 rounded-full object-cover bg-white/10" />
              <h3 className="text-lg font-bold">{t('footer.eventName')}</h3>
            </div>
            <p className="text-white/70 text-sm mb-2">{t('footer.organizer')}</p>
            <p className="text-white/70 text-sm">{t('footer.dates')}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-white/70 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                <span>(03) 584-1001</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                <span>atayal-games@jianshi.gov.tw</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{t('footer.address')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center text-sm text-white/50">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
}
